import React, { ReactElement } from "react";
import { GetStaticProps } from "next";
import SeveralBrandsWrapper from "@components/layouts/severalBrandsWrapper";
import WhyPartnerWithUs from "@components/severalbrands/whyPartnerWithUs";
import FirstSection from "@components/severalbrands/blogs/firstSection";
import { PostType } from "@components/severalbrands/gqlQueries";
import { DomainInfo } from "@components/severalbrands/utils/services";
import initialCall from "@components/severalbrands/utils/initialCall";
import MetaTags from "@components/severalbrands/metaTags";
import {
    getKeyWordsForMetaTags,
    getMetaTitleDescriptionForPage,
} from "@components/severalbrands/utils";

const partnerWitUSDataBlogPage = {
    title: "Why Partner with Us?",
    paragraphs: [
        {
            text: `At Several Brands, you're a growth ally, not just a client; we only succeed when you do. Our vertical experts build and adjust campaigns around your KPIs, backed by lead validation that combines AI screening with human review, and flexible engagement terms rather than a rigid, one-size-fits-all contract. If a lead doesn't fit, we'll swap or credit it, no hassle.`,
            className: "default",
        },
        {
            text: `Ready to turn these strategies into pipeline growth? From lead generation to reporting, we handle the full process so your team can focus on closing.`,
            className:
                "mt-6  3xl:max-w-[1040px] 3xl:text-xl max-w-[740px]  font-light",
        },
    ],
    buttonText: "Talk to Our Sales Team",
};

export const LIMIT = 3;
export default function SeveralBrandsHome({
    allPosts,
    domain,
}: {
    allPosts: PostType[];
    domain: DomainInfo;
}): ReactElement {
    const metaTags = getMetaTitleDescriptionForPage(domain, "Blog");
    return (
        <SeveralBrandsWrapper domainInfo={domain}>
            <MetaTags
                title={metaTags?.title ?? "Blog | SeveralBrands.com"}
                description={
                    metaTags?.description ??
                    "Several Brands LLC is a Performance Marketer Firm. We generate leads, calls and live transfers for local businesses. Furthermore, we promote various products from several affiliate networks."
                }
                keyWords={getKeyWordsForMetaTags(domain)}
            />
            <FirstSection blogsArrProp={allPosts} domainInfo={domain} />
            <div className="mt-32 lg:mt-56 lg:mb-52 mb-20 ">
                <WhyPartnerWithUs partnerWitUSData={partnerWitUSDataBlogPage} />
            </div>
        </SeveralBrandsWrapper>
    );
}

//@ts-ignore
export const getStaticProps: GetStaticProps = async () => {
    return await initialCall("Blog");
};
